import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const HeatPumpsPage = () => <ServicePageTemplate data={servicePageData['heat-pumps']} />;
export default HeatPumpsPage;
